import {IniziativeView} from "./iniziative.view";
export default IniziativeView;
